<script lang="ts">
import { ColorListComponent } from "./color-list.ts";
export default ColorListComponent;
</script>
<template>
    <app-block-ui :blocked="blocked">
        <div class="choose__color-list">
            <span
                class="choose__color"
                v-for="option in preparedOptions"
                :key="option.reference"
            >
                <span
                    class="cr__color tooltip__info"
                    :style="{ backgroundColor: option.hex }"
                    :class="{
                        'dark-color': !option.isLight,
                        'light-color': option.isLight,
                    }"
                    v-tippy="{
                        content:
                            option.label.slice(0, 1).toUpperCase() +
                            option.label.slice(1) +
                            ': ' +
                            option.counter,
                    }"
                >
                    <input
                        type="checkbox"
                        name="color"
                        :value="option.hex"
                        :checked="isOptionSelected(option)"
                        @click="toggleOption(option)"
                    />
                </span>
            </span>
        </div>
    </app-block-ui>
</template>
